import React from 'react';
import { useDirection } from 'App/MuiThemeProvider/useDirection';

export const RTLOverride: React.FC = ({ children }) => {
  const direction = useDirection();
  return <bdo dir={direction}>{children}</bdo>;
};
